import Immutable from 'immutable';

import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/admin/users/types';

const initialState = Immutable.fromJS({
  userListResults: null,
  userListIsLoading: false,
  userListQueryParams: null,
  newAdminErrors: null,
  isNewAdminAdding: false,
  isAdminProfileEditing: false,
  isUserUpdating: false
});

export default reducerCreator(initialState, {
  [types.ADMIN_USERS_SET_LIST_LOADING]: (state, { isLoading }) =>
    state.set('userListIsLoading', isLoading),

  [types.ADMIN_USERS_SET_LIST]: (state, { users }) =>
    state.set('userListResults', users),

  [types.ADMIN_USERS_SET_QUERY_PARAMS]: (state, { queryParams }) =>
    state.set('userListQueryParams', queryParams),

  [types.ADMIN_USERS_SET_ADDING_NEW_ADMIN]: (state, { adding }) =>
    state.set('isNewAdminAdding', adding),

  [types.ADMIN_USERS_SET_NEW_ADMIN_ERRORS]: (state, { errors }) =>
    state.set('newAdminErrors', Immutable.fromJS(errors)),

  [types.ADMIN_USERS_SET_EDITING_ADMIN_PROFILE]: (state, { editing }) =>
    state.set('isAdminProfileEditing', editing),

  [types.ADMIN_USERS_SET_USER_STATUS_UPDATING]: (state, { isUpdating }) =>
    state.set('isUserUpdating', isUpdating),

  [types.ADMIN_USERS_RESET_LIST]: () => 
    initialState,
});



// WEBPACK FOOTER //
// ./src/reducers/admin/admin-users.js